import { getKey } from '~/services/contentful/helpers/functions'

export const AUTHOR_CATEGORIES = {
  'Health Insurance': 'Health Insurance',
  'Life Insurance': 'Life Insurance',
  Energy: 'Energy',
  'Home Loans': 'Home Loans',
  'Personal Loans': 'Personal Loans',
  'Car Insurance': 'Car Insurance',
  'Credit Cards': 'Credit Cards',
  'Compare Club Writer': 'Writers',
  'Compare Club Editor': 'Editorial'
}

// Maps a raw category value (as sent by clients) to its display name, e.g.
// 'Compare Club Writer' -> 'Writers'. Shared by the query builder (which uses
// it for GraphQL aliases) and anything sorting/grouping by category, so the
// two stay in sync.
export const getAuthorCategoryName = category => getKey(category, {
  ...AUTHOR_CATEGORIES,
  Featured: 'Featured'
})
